// extracted by mini-css-extract-plugin
module.exports = {"header":"header__-t9+OU5nT2pF6","subtitle":"subtitle__qTIER500AjGwU"};